/*! onbalance-onvio-components - v1.0.0 - 2022-10-19 - Copyright 2018 Thomson Reuters™. All rights reserved. */
angular.module('onbalance.onvio.components.translate', [])

.constant('onbalanceOnvioComponentsTranslations', {enUS:{'ob.plan.combobox.placeholder':'Select','ob.plan.combobox.label':'OnBalance Plan','ob.related.contacts.combobox.label':'License OnBalance For'}})

;
angular.module('onbalance.onvio.components.templates', ['components/ob-plan-combobox/ob-plan-combobox.2js.html', 'components/ob-related-contacts-combobox/ob-related-contacts-combobox.2js.html']);

angular.module('components/ob-plan-combobox/ob-plan-combobox.2js.html', []).run(['$templateCache', function ($templateCache) {
  'use strict';
  $templateCache.put('components/ob-plan-combobox/ob-plan-combobox.2js.html',
    '<div ng-if="$ctrl.isUnitedKingdom">\n' +
    '    <label>{{ $ctrl.label }} </label>\n' +
    '    <bento-combobox\n' +
    '        get-data="$ctrl.getPlanList()"\n' +
    '        placeholder="{{ $ctrl.placeholder }}"\n' +
    '        ng-model="$ctrl.ngModel"\n' +
    '        label-name="name"\n' +
    '        on-change="$ctrl.onItemSelected(item)"\n' +
    '    >\n' +
    '    </bento-combobox>\n' +
    '</div>');
}]);

angular.module('components/ob-related-contacts-combobox/ob-related-contacts-combobox.2js.html', []).run(['$templateCache', function ($templateCache) {
  'use strict';
  $templateCache.put('components/ob-related-contacts-combobox/ob-related-contacts-combobox.2js.html',
    '<div>\n' +
    '    <label>{{ \'ob.related.contacts.combobox.label\' | translate }} </label>\n' +
    '    <bento-combobox\n' +
    '        get-data="$ctrl.relatedContacts()"\n' +
    '        placeholder="{{ \'ob.plan.combobox.placeholder\' | translate }}"\n' +
    '        ng-model="$ctrl.ngModel"\n' +
    '        label-name="displayName"\n' +
    '        on-change="$ctrl.onItemSelected(item)"\n' +
    '        controller="$ctrl.comboController"\n' +
    '    >\n' +
    '    </bento-combobox>\n' +
    '</div>');
}]);

(function (angular) {
    'use strict';

    var module = angular.module('onbalance.onvio.components.plan.combobox', [
        'pascalprecht.translate',
        'bento.modern',
        'ngResource',
        'bmEnvironment'
    ]);

    module.component('obPlanCombobox', {
        templateUrl: 'components/ob-plan-combobox/ob-plan-combobox.2js.html',
        controller: obPlanComboboxController,
        bindings: {
            ngModel: '=',
            getPlanList: '&?',
            onChange: '&?',
            placeholder: '@?',
            label: '@?'
        }
    });

    obPlanComboboxController.$inject = ['$scope', '$attrs', '$translate', 'obPlanComboboxService', 'bmEnvironment'];

    function obPlanComboboxController($scope, $attrs, $translate, ObPlanComboboxService, bmEnvironment) {
        $scope.$ctrl.isUnitedKingdom = bmEnvironment.isUkCountryCode();

        if (bmEnvironment.isArCountryCode()) {
            $scope.$ctrl.onbalancePlan = {
                id: 'ONBALANCEARBASIC',
                name: 'Basic'
            };
        }

        if (bmEnvironment.isUsCountryCode()) {
            $scope.$ctrl.onbalancePlan = {
                id: 'ONBALANCEUSSELFEMPLOYED',
                name: 'Self Employed'
            };
        }

        $scope.$watch('$parent.$parent.vm.data', function onChange(newVal) {
            if (newVal && $scope.$ctrl.onbalancePlan) {
                newVal.onbalancePlan = $scope.$ctrl.onbalancePlan;
            }
        });

        if (!$attrs.label) {
            $attrs.label = $translate.instant('ob.plan.combobox.label');
        }

        if (!$attrs.placeholder) {
            $attrs.placeholder = $translate.instant('ob.plan.combobox.placeholder');
        }

        if (!$attrs.getPlanList) {
            this.getPlanList = function () {
                return ObPlanComboboxService.get();
            };
        }

        this.onItemSelected = function (item) {
            if ($scope.$ctrl.onChange) {
                $scope.$ctrl.onChange({ item: item });
            }
        };
    }

    module.service('obPlanComboboxService', ['$resource', function PlanComboboxDataService($resource) {
        return $resource('/api/smbcenter/v1/products', {}, {
            get: {
                method: 'GET',
                isArray: true
            }
        });
    }]);

})(window.angular);

(function (angular) {
    'use strict';

    var module = angular.module('onbalance.onvio.components.related.contact.combobox', [
        'pascalprecht.translate',
        'bento.modern',
        'ngResource',
        'bmEnvironment',
        'bmPermission',
        'onbalance.related.contacts.combobox.service'
    ]);

    module.component('obRelatedContactCombobox', {
        templateUrl: 'components/ob-related-contacts-combobox/ob-related-contacts-combobox.2js.html',
        controller: obRelatedContactComboboxController,
        bindings: {
            ngModel: '=',
            onChange: '&?',
            getData: '&?',
            companyId: '<',
            clientId: '<'
        }
    });

    obRelatedContactComboboxController.$inject = ['obRelatedContactsComboboxService', 'bmEnvironment', '$q', '$translate'];

    function obRelatedContactComboboxController(obRelatedContactsComboboxService, bmEnvironment, $q, $translate) {
        var that = this;
        that.isUnitedKingdom = bmEnvironment.isUkCountryCode();
        that.comboController = {};
        that.relatedContacts = {};
        that.relatedComboLabel = $translate.instant('ob.related.contacts.combobox.label');
        that.filterContactCombo = '{"UseOr":true,"items":[{"by":"relationshipTypeSystemId","op":"EQ","value":"OWNER"},{"by":"relationshipTypeSystemId","op":"EQ","value":"LANDLORD"}]}';

        that.$onInit = function init(){
            that.relatedContacts = that.getData || that.getRelatedContacts;
        };

        that.getRelatedContacts = function getContacts(){
            var defer = $q.defer();
            //get client id to find that clients contacts
            obRelatedContactsComboboxService.getClientContactId({companyId: that.companyId, clientId: that.clientId}).$promise.then(function onSuccess(result){
                //then get a list of related contacts
                obRelatedContactsComboboxService.getRelatedContact({companyId: that.companyId, contactId: result.primaryContact.id, filter: that.filterContactCombo}).$promise.then(function onFinish(result){
                    //if only one related contact exists, automatically fill in the combo with it
                    if(result.items.length === 1){
                       that.ngModel = result.items[0];
                       that.onItemSelected(that.ngModel);
                    }
                    //load the results into an array to display them in the combo
                    for(var i = 0; i < result.items.length; i++) {
                        result.items[i].displayName = result.items[i].contact.name;
                    }
                    defer.resolve(result.items);
                });
            });
            return defer.promise;
        };

        that.onItemSelected = function onItemSelected(item) {
            if (that.onChange) {
                that.onChange({ item: item });
            }
        };
    }
})(window.angular);

(function (angular) {
    'use strict';
    var module = angular.module('onbalance.related.contacts.combobox.service', [
        'ngResource'
    ]);

    module.service('obRelatedContactsComboboxService', service);

    service.$inject = ['$resource'];

    function service($resource) {
        //TO DO get the exact endpoint to call to get the related contacts
        return $resource('/api/core/v3/companies/', {}, {
            getRelatedContact: {
                url: '/api/core/v3/companies/:companyId/contacts/:contactId/relationships?filter=:filter',
                method: 'GET',
                params: {
                    companyId: '@companyId',
                    contactId: '@contactId',
                    filter: '@filter',
                }
            },
            getClientContactId: {
                url: '/api/core/v3/companies/:companyId/clients/:clientId',
                method: 'GET',
                params: {
                    companyId: '@companyId',
                    clientId: '@clientId'
                }
            }
        });
    }

  })(window.angular);

(function (angular) {
    'use strict';
    /*
    *   This logic allow the posibility of have an unique module with only one name.
    *   Also allow the creation of a new module that wrap more module.
    *
    *   This also inject a few useful modules like translate, the templates (when is fonded)
    *   Be careful when modify this code, the components structure relies on this.
    *
    *   Only the first block of variable and the translation section should me modified to customize the component.
    *   The translation only should be modified to add more languages
    *
    *   * componentName: Name of the component (name on the package.json)
    *   * moduleName: Name to the Angular Module
    *   * modulesToInject: Array with Angular Modules names to wrap in the main module
    */

    var componentName = 'onbalance.onvio.components';
    var moduleName = 'onbalance.onvio.components';
    var modulesToInject = [
      'onbalance.onvio.components.plan.combobox',
      'onbalance.onvio.components.related.contact.combobox',
      'onbalance.related.contacts.combobox.service',
      'ngResource'
    ];

    var module;
    if (existModule(moduleName)){
      module = angular.module(moduleName);
      module.requires.unshift('pascalprecht.translate');
      module.requires.unshift(componentName + '.translate');
      if (existModule(componentName + '.templates')){
        module.requires.unshift(componentName + '.templates');
      }
      modulesToInject.forEach(function(dep){
        module.requires.unshift(dep);
      });
    } else {
      var dependencies = [];
      dependencies.push('pascalprecht.translate');
      dependencies.push(componentName + '.translate');
      if (existModule(componentName + '.templates')){
        dependencies.push(componentName + '.templates');
      }
      dependencies = dependencies.concat(modulesToInject);

      module = angular.module(moduleName, dependencies);
    }

    function existModule(name){
      try {
          return !!angular.module(name);
      } catch (ex) {
        if (ex.message.indexOf('[$injector:nomod]') !== -1){
          return false;
        } else {
          throw ex;
        }
      }
    }

})(window.angular);
